import React, { useCallback, FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Text, cn, ClassName } from 'Modules/ui';

import styles from './index.module.scss';


type RadioProps<TValue = string> = ClassName & FieldRenderProps<TValue, HTMLInputElement> & {
    id: string;
    title: string;
}

export const RadioField: FC<RadioProps> = ({ id, input, title, className }) => (
    <Text component='div' className={cn(className, styles.radio)}>
        <input id={id} {...input} />
        <span onClick={useCallback(
            () => input.onChange(input.value),
            [input],
        )}
        />
        <label htmlFor={id}>{title}</label>
    </Text>
);
